import type {ConsultRefundParams} from 'domain/usecases';
import {getCurrentAccountAdapter} from 'main/adapters/current-account-adapter';
import {makeGetConsultRefunds} from 'main/factories/usecases';
import {UserTypeEnum} from 'presentation/constants';
import {getUserInfoFromToken} from 'presentation/utils';

export const getConsultRefund = async ({
	protocol,
	page,
	limit,
	startDate,
	endDate,
	protocolSituation,
	modalityCode,
}: ConsultRefundParams) => {
	const {
		beneficiary: {tipoUsuarioC, cdUsuario},
	} = getCurrentAccountAdapter();

	const isHolder = tipoUsuarioC === UserTypeEnum.HOLDER;
	const userCode = getUserInfoFromToken().cdUsuario;

	const params = {
		userCode: cdUsuario,
		protocol: protocol || undefined,
		patientCode: isHolder ? undefined : userCode,
		startDate: startDate || undefined,
		endDate: endDate || undefined,
		limit,
		page,
		protocolSituation,
		modalityCode,
	};

	const response = await makeGetConsultRefunds().get(params);

	if (!response) {
		return {
			items: [],
			total: 0,
			pages: 0,
		};
	}

	const pages = limit
		? Math.ceil(response.content.total / limit)
		: Math.ceil(response.content.total / response.content.totalPerPage);

	return {
		items: response?.content?.consults,
		total: response?.content?.total,
		pages,
	};
};
